<template>
  <div style="margin:  0 auto; width: 80%">
    <el-row style="text-align: left;height: 40px; margin-top: 10px">

      <el-col>
        <el-button size="small" @click="gotoLogin">去登录</el-button>
       <!-- <el-button size="small" @click="gotoIndex">去首页</el-button>-->
        订单号：<el-input v-model="nick" size="small" type="text"  style="width:200px"></el-input>
        <el-button type="primary" size="mini" @click="getAccData">搜索</el-button>
      </el-col>

    </el-row>
    <el-row>
      <el-col>
        <el-select v-model="funValue" size="small" style="width: 120px" placeholder="请选择">
          <el-option
            v-for="item in funOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="accData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  prop="nick" label="用户名" width="160px"></el-table-column>
          <el-table-column  prop="subNick" label="子号" width="160px"></el-table-column>
          <el-table-column  prop="userIp" label="IP" width="160px"></el-table-column>

          <el-table-column  prop="oprTime" label="登录时间" width="160px"></el-table-column>
          <el-table-column  prop="deadLine" label="过期时间" width="160px"></el-table-column>
          <el-table-column  prop="version" label="版本" width="80px"></el-table-column>
          <el-table-column  prop="sessionkey" label="session" ></el-table-column>
          <el-table-column  label="" width="100px">
            <template slot-scope="scope">

              <el-button type="text" size="mini"  style="display: inline" @click="setCurrUser(scope.$index, scope.row)">更新</el-button>
              <el-button type="text" size="mini"  style="display: inline" @click="stopThread(scope.$index, scope.row)">停止</el-button>
            </template>
          </el-table-column>

          </el-table>
        </el-col>
      </el-row>
    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"

    export default {
        name: "AdmAccess",
      data(){
          return{
            nick:'',
            pageObject: {
              pageCurrent: 1,
              rowCount: 9,
              pageSize: 10,
            },
            funValue:'GetTrades',
            funOpto:[{label:'订单',value:'GetTrades'},{label:'备注',value:'GetMemo'},{label:'商品',value:'GetItems'},{label:'Sku',value:'GetSkus'}],
            accData:[],
          }
      },
      methods:{
        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getAccData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getAccData();
        },
        gotoLogin:function(){
          this.$router.replace({name: 'AdmLogin'})
        },
        gotoIndex:function(){
          this.$router.replace({name: 'Index'})
        },

        getDaysBetween:function(dateString1,dateString2){
          var  startDate = Date.parse(dateString1);
          var  endDate = Date.parse(dateString2);
          var days=(endDate - startDate)/(1*24*60*60*1000);
          // alert(days);
          return  days;
        },
        getAccData:function () {
          let param ={
            nick: this.nick,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          };
          console.log("admin");
          $api.post("/getacc", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              let accData = dataResult.data.acc;
              let pageObject = dataResult.data.pageObject;
              console.log(accData);
              this.accData = accData;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
            }
            else{
              this.$message.error(dataResult.message);
            }
          })
        },
        setCurrUser:function (index, row) {
          console.log(row.deadLine);
          console.log(row.deadLine.substring(0,10));
          let date = new Date();
          let days = parseInt((Date.parse(row.deadLine) - date)/(1*24*60*60*1000));
          let param ={
            username: row.nick,
            subnick: row.subNick,
            secret: row.sessionkey
          };
          $api.post("/login", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              storage.set("nick", dataResult.data.nick);
              storage.set("subnick", dataResult.data.subnick);
              storage.set("days",days);
              storage.set("deadline", row.deadLine.substring(0,10));
              storage.set("token", dataResult.data.token);
            }
          })
        },
        getDaysBetween:function(dateString1,dateString2){
          var  startDate = Date.parse(dateString1);
          var  endDate = Date.parse(dateString2);
          var days=(endDate - startDate)/(1*24*60*60*1000);
          // alert(days);
          return  days;
        },
        stopThread:function (index, row) {
          let param ={
            nick: row.nick,
            subnick: row.subNick,
            funName: this.funValue,
          };
          $api.post("/stop", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.$message.success("已更新状态")
            }else{
              this.$message.error(dataResult.message);
            }
          })
        }
      },
      mounted() {
          let token = storage.get("pass");
          console.log(token);
          if(token != null){
            this.getAccData();
          }else {
            this.$router.replace({name:'AdmLogin'});
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/admin/AdmAccess.vue